import  { useState, useContext, useRef, useEffect } from "react";
import { useParams, matchPath, useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import addNoted from "../../../images/AtomFavourite Copy/png/AtomFavourite Copy.png";
import { getReAdvisorDetail, exportPdf } from '../../../Config/config'
import axios from "axios";
import moment from "moment";
import { UserContext } from "../../../Contexts/UserContext";
import AddNotePopover from "../../shared/AddNotePopover";
import RandomLogo from "../../RandomLogo";
import CompanyLogo from "../../CompanyLogo";
import Constants from "../../../Constants";
import routePathSegments, { routeNames } from "../../../routeSegments";
import AlertPopUp from "../../DetailPage/AlertPopUp";
import PENotesPopup from '../../NotesPopup/PENotesPopup'
import SendDealPopUp from "../../SendDealPopUp";
import AddNote from "../../../Pages/addNote"
import PdfDownloader from "../../shared/PdfDownloader";
import addNotedActive from '../../../images/AtomFavourite Copy 3/png/AtomFavourite Copy 3.png';
import AdvisorAllCompaniesInvestments from "./AdvisorToAllInvestments";
import MonthPickerComponent from "../../../Utils/MonthPickerComponent";
import AdvisorCompaniesAllExits from "./AdvisorToAllExits";
import AdvisorToAllInvestors from "./AdvisorToAllInvestors";
import AdvisorToAllAcquirer from "./AdvisorToAllAcquirer";
import { PeFilterContext } from "../../../Contexts/PeFilterContext";
import Loader from "../../Loader";

const AdvisorAllPortfolioDetail = (props) => {
    
    const { companyId } = useParams();
    let advisorProfileId = parseInt(companyId)
    const location = useLocation();    
    const [showNote, setShowNote] = useState(false)
    // const [open, setOpen] = useState()
    const { getToken, isStudent } = useContext(UserContext);
    const [profileHighlights, setProfileHighlights] = useState([]);
    const [isProfileLoading, setIsProfileLoading] = useState(true);
    const [isCompanyExit, setIsCompanyExit] = useState([])
    const [companyInvestment, setCompanyInvestment] = useState([])
    const [advisorAcquirer, setAdvisorAcquirer] = useState([]);
    const [toInvestor, setToInvestor] = useState([])
    const [advisorNews, setAdvisorNews] = useState([])
    const { setMonthPickerValue } = useContext(PeFilterContext);


   /**
    * The function `sendDetails` sends a POST request to a specified endpoint with certain parameters
    * and headers, and then sets various state variables based on the response data.
    */
    const sendDetails = () => {
        axios.post(getReAdvisorDetail, {
            "advisor_id": advisorProfileId,
            "advisor_type": props?.advisorType,
        }, {
            headers: { "Authorization": getToken() }
        }).then(response => {
            if (response.status === 200) {
                setProfileHighlights(response.data?.advisor_detail?.advisor_profile)
                setIsCompanyExit(response.data?.advisor_detail?.to_exits_investment)
                setAdvisorAcquirer(response.data?.advisor_detail?.to_acquirer_investment)
                setToInvestor(response.data?.advisor_detail?.to_investors_investment)
                setCompanyInvestment(response.data?.advisor_detail?.to_companies_investment)
                setIsProfileLoading(false);
                setAdvisorNews(response.data?.advisor_detail?.news_letter)
                // setOpen(false)
            }
        }).catch(error => {
            console.log(error, "API not working")
        })
    }


    useEffect(() => {
        sendDetails();
    }, [advisorProfileId])

    const menuRef = useRef();

    const reMatch = matchPath(`${routePathSegments.re}/*`, location.pathname); 


   /**
    * The function `subTypeMasterId` returns a sub category ID based on the value of the `section`
    * property in the `props` object.
    * @returns The function `subTypeMasterId` returns the subcategory ID based on the value of
    * `props?.section`.
    */
    const subTypeMasterId =() =>{
       
        if(props?.section == Constants.primaryMasterSubIds.re_advisor_investment_id){
          return Constants.subCategoryIds.re_advisor_investment_id
        }
        else if(props?.section == Constants.primaryMasterSubIds.re_advisor_exits_id){
          return Constants.subCategoryIds.re_advisor_exits_id
        }
        
        else if(props?.section == Constants.primaryMasterSubIds.re_advisor_otherma_id){
          return Constants.subCategoryIds.re_advisor_otherma_id
        }
        
      } 

      useEffect(() => {
        setMonthPickerValue(["2004-01-01", moment().startOf('second').format("YYYY-MM-DD")]);
    }, [])

    document.title = `${profileHighlights?.advisor_name ? profileHighlights?.advisor_name + " - " : ""}RE Legal Advisors - Venture Intelligence`;
    
    return (
        <>
            <div className="bg-[#FFFFFF] relative">
                <nav className="flex p-1 border-b " aria-label="Breadcrumb">
                    <ol role="list" className="flex items-center space-x-1">
                        <li className='flex items-center'>
                            <div className='flex items-center'>
                                <NavLink to={location.state?.prevPath != null
                                    ? location.state?.prevPath
                                    : reMatch != null ? routeNames.RE_advisor :
                                        ""} className="ml-1 text-[12pt] lg:text-[12px] text-[#666666]">
                                    Advisors</NavLink>
                            </div>
                        </li>
                        <li className='flex items-center'>
                            <div className="flex items-center">
                                <span className=" text-[12px] text-[#666666] mr-1">/</span>
                                <span className="text-[11pt] lg:text-[12px] text-[#666666] font-semibold"
                                    aria-current="page">{profileHighlights?.advisor_name ? profileHighlights?.advisor_name : "--"}</span>
                            </div>
                        </li>
                    </ol>
                </nav>
                {/* <!-- BarRaiser--> */}
                {Object.keys(profileHighlights).length <= 0 ?
                    <table className="h-[10rem] w-full bg-[#FFFFFF] ">
                        <center><div role="status" className="bg-white  h-[16rem]">
                            <svg className="relative top-[6rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                            </svg>
                        </div></center>
                    </table>
                    :
                    <div className="pl-5 pr-3 ">
                        <div className=" pb-4 pt-6 bg-[#FFFFFF]">
                            <ul role="list" >
                                <li className="w-full flex ">
                                    <div className=" rounded-md">
                                        {/* <CompanyLogo id={props.id} page="detail page"/> */}
                                        {profileHighlights?.icon_path == "default.png" || profileHighlights?.icon_path == "/default.png" || !profileHighlights?.icon_path ?
                                            <RandomLogo name={profileHighlights?.advisor_name} page="detail page" />
                                            :
                                            <CompanyLogo name={profileHighlights?.advisor_name} page="detail page" logo={profileHighlights?.icon_path} />

                                        }
                                    </div>

                                    <div className="ml-3 flex flex-1 flex-col">
                                        <span className="text-[#333333] text-[22px] font-semibold leading-[24px]" href="#"> {profileHighlights?.advisor_name ? profileHighlights?.advisor_name : "--"} </span>
                                        <span className=" text-[12pt] leading-[16pt] text-[#333333]  lg:text-[13px] lg:leading-[17px] font-sans_roman_body ">{profileHighlights?.advisor_type?.trim() !== "" ? profileHighlights.advisor_type : "--"}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        {/* <!-- tags--> */}

                    </div>
                }


            </div>
            {isProfileLoading ? <Loader /> :
                <div className="bg-[#EDEDED] ">
                    {props?.category === "investments" && <AdvisorAllCompaniesInvestments companyInvestment={companyInvestment} advisorName={profileHighlights?.advisor_name} advisorType={props?.advisorType}/>}
                    {props?.category === "exits" && <AdvisorCompaniesAllExits companyExits={isCompanyExit} advisorName={profileHighlights?.advisor_name} advisorType={props?.advisorType}/>}
                    {props?.category === "investors" && <AdvisorToAllInvestors toInvestor={toInvestor} advisorName={profileHighlights?.advisor_name} advisorType={props?.advisorType}/>}
                    {props?.category === "acquirers" && <AdvisorToAllAcquirer toAcquirer={advisorAcquirer} advisorName={profileHighlights?.advisor_name} advisorType={props?.advisorType}/>}                
                </div>
            }
        </>
    )

}

export default AdvisorAllPortfolioDetail